export default __webpack_public_path__ + "static/media/3d-glasses-2.cd11d146.png";